import * as iconv from "iconv-lite";
import { isEmpty } from "./string";

const NOT_KANJI_START = 0x8140;
const NOT_KANJI_END = 0x84fc;
const ROMAN_NUM_START = 0x8754;
const ROMAN_NUM_END = 0x875d;
const KABU_MARK = 0x878a;
const FIRST_KANJI_START = 0x889f;
const FIRST_KANJI_END = 0x9872;
const SECOND_KANJI_START = 0x989f;
const SECOND_KANJI_END = 0xeaa4;
const NEC_IBM_START = 0xed40;
const NEC_IBM_END = 0xeeff;
const IBM_START = 0xfa40;
const IBM_END = 0xfc4b;
const QUESTION = 0x3f;
const SURROGATE_PAIR_START = 0x10000;

/**
 * 文字列内に禁止文字列があれば、禁止文字列を取得
 * @param {String} value 対象文字列
 * @returns {String} 禁止文字列がなければブランク、禁止文字列があれば該当する禁止文字列を返却
 */
export const getProhibitedCharacters = (value) => {

  let prohibitedChars = "";

  if(!isEmpty(value)) {
    // 入力値をコードポイントに変換
    const codePoints = [];
    for (let i = 0, charCount = 0; i < value.length; i += charCount) {
      const codePoint = value.codePointAt(i);
      if (typeof codePoint !== "undefined") {
        codePoints.push(codePoint);
        charCount = codePoint >= SURROGATE_PAIR_START ? 2 : 1;
      }
    }

    // 文字化け後の文字と被るため、はてなマークを除外
    const targetStringSet = new Set();
    codePoints
      .map((x) => String.fromCodePoint(x))
      .filter((x) => !(x === "?"))
      .forEach((x) => {
        targetStringSet.add(x);
      });

    // 入力値をshift-jis(MS932)でエンコード
    const encodeResultArray = [...targetStringSet].map((x) => ({
      inputValue: x,
      encodedValue: iconv.encode(x, "MS932"),
    }));

    // 文字化け検証
    encodeResultArray
      .filter(
        (x) =>
          x.encodedValue.byteLength === 1 &&
          new Uint8Array(x.encodedValue)[0] === QUESTION
      )
      .forEach((x) => {
        prohibitedChars += x.inputValue;
      });

    const Buffer = require("buffer").Buffer;

    // 全角文字を検証
    encodeResultArray
      .filter((x) => x.encodedValue.byteLength === 2)
      .forEach((x) => {
        const hex = parseInt(Buffer.from(x.encodedValue).toString("hex"), 16);
        if (
          // 非漢字
          !(NOT_KANJI_START <= hex && hex <= NOT_KANJI_END) &&
          // NEC特殊文字(Ⅰ Ⅱ Ⅲ Ⅳ Ⅴ Ⅵ Ⅶ Ⅷ Ⅸ Ⅹ)
          !(ROMAN_NUM_START <= hex && hex <= ROMAN_NUM_END) &&
          // NEC特殊文字(㈱)
          !(hex === KABU_MARK) &&
          // 第一水準漢字
          !(FIRST_KANJI_START <= hex && hex <= FIRST_KANJI_END) &&
          // 第二水準漢字
          !(SECOND_KANJI_START <= hex && hex <= SECOND_KANJI_END) &&
          // NEC選定IBM拡張文字
          !(NEC_IBM_START <= hex && hex <= NEC_IBM_END) &&
          // IBM拡張文字
          !(IBM_START <= hex && hex <= IBM_END)
        ) {
          prohibitedChars += x.inputValue;
        }
      });
  }
  return prohibitedChars;
};
